module.exports = __webpack_public_path__ + "static/img/gouxuan.413ce0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gouxuan.png
// module id = 9Z46
// module chunks = 20